import React from "react";
import Modal from "@material-ui/core/Modal";
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch} from "react-redux";
import {clearCart} from "../../core/redux/ActionCreator";

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '70vw',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

const ConfirmationModal = (props) => {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const dispatch = useDispatch();

    const handleOnClick = () => {
        dispatch(clearCart());
        props.onSubmit();
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <h2>Attention</h2>
            <p>Changing dealers will delete all the items in your cart.</p>
            <button type="button" onClick={handleOnClick}>OK</button>
        </div>
    );

    return (
        <div>
            <Modal aria-labelledby="Confirm Dealer Change"
                   aria-describedby="Confirm Dealer Change"
                   open={props.show}>
                {body}
            </Modal>
        </div>
    )
};

export default ConfirmationModal
